// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3h6cT","log":"ModalInventoryLogs_log__1cIe7","date":"ModalInventoryLogs_date__4oc-N","userName":"ModalInventoryLogs_userName__3rq6o"};